import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocationDetailsRepository } from '@/core/domain/location-details/repositories/location-details.repository';
import { GetLocationDetailsUseCase } from '@/core/domain/location-details/usecases/getLocationDetails.usecase';
import { LocationDetailsImplRepository } from './location-details-impl.repository';

const GetLocationDetailsUseCaseFactory = (
    locationDetailsRepository: LocationDetailsRepository,
) => new GetLocationDetailsUseCase(locationDetailsRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: GetLocationDetailsUseCase,
            useFactory: GetLocationDetailsUseCaseFactory,
            deps: [LocationDetailsRepository],
        },
        {
            provide: LocationDetailsRepository,
            useClass: LocationDetailsImplRepository,
        },
    ],
})
export class LocationDetailsDataModule {}
